class ShopTheLook extends HTMLElement {
  constructor() {
    super();
    this.slider = new Flickity( '.js-shop-the-look .stl-carousel', {
      cellAlign: 'center',
      contain: true,
      initialIndex: 1,
      wrapAround: true, 
      pageDots: false
    }) 

    this.desktopPins = this.querySelectorAll('.shop-the-look--desktop quick-view')
    this.mobilePins = this.querySelectorAll('.shop-the-look--mobile quick-view') 

    this.activePinIndex = 0

    this.handleArrowSvg()
    this.turnActivePin('on') 

    if (this.slider) {
      this.slider.on('change', (index) => { 
        let activeSlideIndex = index 
        if (activeSlideIndex != this.activePinIndex) {
          this.turnActivePin('off')
          this.activePinIndex = activeSlideIndex
          this.turnActivePin('on')
        }
      })
    }
    this.addEventListener('mouseover', this.handleMouseOver)
  }

  handleMouseOver(evt) {
    if (evt.target.closest('quick-view')) {
      let pdIndex = evt.target.closest('quick-view').dataset.index 
      this.slider?.select(pdIndex) 
    }
  }

  turnActivePin(state) {
    const stateMap = {
      on: 'add',
      off: 'remove'
    }
    this.desktopPins[this.activePinIndex].classList[stateMap[state]]('is-active')
    this.mobilePins[this.activePinIndex].classList[stateMap[state]]('is-active') 
  }

  handleArrowSvg() {
    this.arrows = this.querySelectorAll('.flickity-prev-next-button')
    this.arrowSvgs = this.querySelectorAll('.flickity-nav svg') 
    this.arrows.forEach((arrow, index) => { 
      arrow.classList.add('flickity-nav'),
      arrow.removeChild(arrow.lastElementChild),
      arrow.appendChild(this.arrowSvgs[index])
    }) 
  }
}

customElements.define('shop-the-look', ShopTheLook)